export default __webpack_public_path__ + "static/media/tiktok.b069ee13.svg";